import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Logo, Btn, Input } from '../../components/UI';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

const BANK_IN = [['Account Name','M/S MS DISCOVERIES'],['Account Number','759601010050400'],['Bank','UNION BANK OF INDIA'],['Branch','PARAMATHI VELUR'],['IFSC Code','UBIN0575968'],['SWIFT Code','UBININBBBERD']];
const BANK_US = [['Account Name','MS DISCOVERIES'],['Account Number','8336276214'],['ACH Routing','026073150'],['Bank','Community Federal Savings Bank'],['Address','5 Penn Plaza, New York, NY 10001, US']];

export default function Payment() {
  const [tab, setTab] = useState('indian');
  const [txnId, setTxnId] = useState('');
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useAuth();
  const navigate = useNavigate();

  const copy = (text, e) => { navigator.clipboard.writeText(text); e.target.textContent='✓'; setTimeout(()=>e.target.textContent='Copy',1500); };

  const handleSubmit = async () => {
    if (!txnId.trim()) { alert('Please enter transaction ID'); return; }
    const token = localStorage.getItem('msreach_token');
    if (!token) { navigate('/login'); return; }
    setLoading(true);
    try {
      const { data } = await api.post('/api/billing/submit', {
        plan_id: localStorage.getItem('msreach_reg_plan'),
        billing_cycle: localStorage.getItem('msreach_reg_billing'),
        currency: localStorage.getItem('msreach_reg_currency'),
        transaction_id: txnId, payment_type: 'new'
      });
      if (data.success) setSuccess(true);
      else alert(data.message);
    } catch (err) { alert(err.response?.data?.message||'Error'); }
    finally { setLoading(false); }
  };

  const bankData = tab==='indian' ? BANK_IN : BANK_US;

  return (
    <div style={{ minHeight:'100vh',background:'var(--bg)',display:'flex',alignItems:'center',justifyContent:'center',padding:'80px 24px 40px' }}>
      <div style={{ background:'var(--bg-card)',border:'1px solid var(--border)',borderRadius:16,padding:40,width:'100%',maxWidth:560 }}>
        <div style={{ display:'flex',justifyContent:'center',marginBottom:24 }}><Logo size={40} /></div>
        {success ? (
          <div style={{ textAlign:'center',padding:'20px 0' }}>
            <div style={{ fontSize:56,marginBottom:16 }}>✅</div>
            <h2 style={{ color:'var(--green)',marginBottom:8 }}>Payment Submitted!</h2>
            <p style={{ color:'var(--text-secondary)',fontSize:14,marginBottom:24 }}>Your payment is under review. Admin will approve within 24 hours.</p>
            <Btn onClick={()=>navigate('/login')}>Go to Login</Btn>
          </div>
        ) : (
          <>
            <h1 style={{ fontSize:22,fontFamily:'Sora',fontWeight:700,marginBottom:8 }}>Complete Your Payment</h1>
            <p style={{ color:'var(--text-muted)',fontSize:14,marginBottom:24 }}>Transfer the amount to our bank and submit your transaction ID.</p>
            <div style={{ display:'flex',gap:8,marginBottom:20 }}>
              {[['indian','🇮🇳 Indian Bank'],['us','🇺🇸 US Bank']].map(([t,l])=>(
                <button key={t} onClick={()=>setTab(t)} style={{ flex:1,padding:'10px',borderRadius:8,border:'none',background:tab===t?'var(--green)':'var(--bg-card2)',color:tab===t?'#000':'var(--text-muted)',fontWeight:600,cursor:'pointer',transition:'0.2s' }}>{l}</button>
              ))}
            </div>
            <div style={{ background:'var(--bg)',border:'1px solid var(--border)',borderRadius:12,padding:20,marginBottom:20 }}>
              <div style={{ fontSize:13,fontWeight:600,color:'var(--text-secondary)',marginBottom:16 }}>🏦 {tab==='indian'?'Union Bank of India':'Community Federal Savings Bank'}</div>
              {bankData.map(([k,v])=>(
                <div key={k} style={{ display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10 }}>
                  <span style={{ fontSize:12,color:'var(--text-muted)' }}>{k}</span>
                  <div style={{ display:'flex',alignItems:'center',gap:8 }}>
                    <span style={{ fontSize:13,fontWeight:600 }}>{v}</span>
                    {['Account Number','IFSC Code','ACH Routing','SWIFT Code'].includes(k) && (
                      <button onClick={e=>copy(v,e)} style={{ background:'var(--bg-card)',border:'1px solid var(--border)',color:'var(--text-muted)',padding:'3px 10px',borderRadius:6,fontSize:11,cursor:'pointer' }}>Copy</button>
                    )}
                  </div>
                </div>
              ))}
            </div>
            <div style={{ background:'var(--bg)',border:'1px solid var(--border)',borderRadius:12,padding:20 }}>
              <div style={{ fontSize:14,fontWeight:600,marginBottom:16 }}>📋 Submit Transaction ID</div>
              <Input label="Transaction ID / Reference Number *" value={txnId} onChange={e=>setTxnId(e.target.value)} placeholder="Enter your transaction ID" />
              <Btn onClick={handleSubmit} disabled={loading} full size="lg">{loading?'Submitting...':'Submit Payment for Approval'}</Btn>
            </div>
            <p style={{ textAlign:'center',marginTop:16,fontSize:13,color:'var(--text-muted)' }}>Need help? <a href="mailto:halo@msdiscoveries.com" style={{ color:'var(--green)' }}>halo@msdiscoveries.com</a></p>
          </>
        )}
      </div>
    </div>
  );
}